import React from "react";
import { ActivityIndicator } from "react-native";

import { brandColor } from "../globalStyle";
import tw from "twrnc";

export const AppIndicatorRounded = ({ style, ...props }) => {
  return (
    <ActivityIndicator
      color={"#fff"}
      style={[tw`rounded-full h-8 w-8 bg-black/50`, style]}
      {...props}
    />
  );
};

const AppActivityIndicator = (props) => {
  return <ActivityIndicator animating={true} color={brandColor} {...props} />;
};

export default AppActivityIndicator;
